import {
  BrowserRouter as Router,
  Routes as Switch,
  Route,
  Navigate as Redirect,
} from 'react-router-dom'
import { publicRoutes, privateRoutes } from './routeConstants'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useSelector } from 'react-redux'
import { Store } from '../redux/Actions'
import Header from '../components/Header'
import { Suspense, useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'
import messages_hi from '../translations/hi.json'
import messages_en from '../translations/en.json'
import { allAccess } from '../util/userBasedAuth'
import { BarsLoader } from '../components/Loader'
import { getDecryptRole } from '../util/crypto'
import UserNotFound from '../components/UserNotFound'

export default function Routes() {
  const userType = getDecryptRole() || ''
  const urlParams = new URLSearchParams(window.location.search)
  const next = urlParams.get('next')

  const isLoggedout = useSelector(
    (state: Store) => state.userDataReducer.isLoggedout
  )
  const isLoggedin = useSelector(
    (state: Store) => state.userDataReducer.isLoggedin
  )
  const language = 'en' //useSelector((state: Store) => state.userDataReducer.local);
  const messages = {
    en: messages_en,
    hi: messages_hi,
  }
  const [message, setMessage] = useState(messages['en'])

  useEffect(() => {
    if (language === 'en') {
      setMessage(messages['en'])
    }
  }, [language])

  return (
    <div>
      <IntlProvider messages={message} locale={language}>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          closeButton={false}
          pauseOnHover
          limit={1}
        />
        <Router basename={process.env.PUBLIC_URL}>
          <Suspense fallback={<BarsLoader height="100vh" />}>
            <Switch>
              {!isLoggedin ? (
                <>
                  {publicRoutes.map(
                    ({ path, element: Element, navBar }, index) => (
                      <Route
                        key={index}
                        path={path}
                        element={
                          <div id="app">
                            <div className="content-wrapper">
                              {navBar && <Header />}
                              <Element />
                            </div>
                          </div>
                        }
                      />
                    )
                  )}
                  <Route
                    path="/"
                    element={
                      <Redirect
                        to={`/auth/login${
                          !['/', '/home']?.includes(window.location.pathname) &&
                          !isLoggedout
                            ? `?next=${
                                window.location.pathname +
                                window.location.search
                              }`
                            : ''
                        }`}
                        replace
                      />
                    }
                  />
                  <Route path="*" element={<Redirect to="/" replace />} />
                </>
              ) : next ? (
                <Route
                  path="/auth/login"
                  element={<Redirect to={next} replace />}
                />
              ) : (
                <Route
                  path="/auth/login"
                  element={<Redirect to={'/home'} replace />}
                />
              )}

              {isLoggedout == false && isLoggedin === true && (
                <>
                  {allAccess?.includes(userType) ? (
                    <>
                      {privateRoutes.map(
                        (
                          { path, element: Element, navBar, props, roles = [] },
                          index
                        ) =>
                          roles?.includes(userType) && (
                            <Route
                              key={index}
                              path={path}
                              element={
                                <div id="app">
                                  {navBar && <Header />}
                                  <Element {...props} />
                                </div>
                              }
                            />
                          )
                      )}
                      <Route
                        path="/"
                        element={<Redirect to={next || '/home'} replace />}
                      />
                      <Route
                        path="*"
                        element={<Redirect to="/page-not-found" replace />}
                      />
                    </>
                  ) : (
                    <>
                      <Route
                        path="/user-not-found"
                        element={<UserNotFound />}
                      />
                      <Route
                        path="/"
                        element={<Redirect to="/user-not-found" replace />}
                      />
                      <Route
                        path="*"
                        element={<Redirect to="/user-not-found" replace />}
                      />
                    </>
                  )}
                </>
              )}
            </Switch>
          </Suspense>
        </Router>
      </IntlProvider>
    </div>
  )
}
